<template>
    <div>
        <h2>Dashboard</h2>
        <vs-divider/>
        <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="right" vs-align="center" vs-w="12">
                <vs-card>
                    <div slot="header">
                        <h3>
                        Help
                        </h3>
                    </div>
                    <div>
                        <span>If you need any assistance please contact:</span><br /><br />
                        <span><b>Phone (English, Finnish, Swedish): +358 10 411 0680</b></span><br /><br />
                        <span><b>Email (English, Finnish, Swedish): support@fredmangroup.com</b></span>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>
        <Subscription :dashboardView="true" @subscription-loaded="subscriptionLoaded" @sub-plan-update="subscriptionPlanUpdated" />
        <Invoices :key="invoiceKey" />
        <Cards v-if="isSubscriptionLoaded" />
    </div>
</template>
<script>
import Invoices from './Invoices.vue'
import Subscription from './Subscription.vue'
import Cards from './Cards'

export default {
    components: {
        Invoices,
        Subscription,
        Cards
    },
    data() {
        return {
            isSubscriptionLoaded: false,
            invoiceKey: 0
        }
    },
    methods: {
        subscriptionLoaded() {
            this.isSubscriptionLoaded = true;
        },
        subscriptionPlanUpdated() {
            // Force refresh invoices
            this.$store.commit('UPDATE_USER_INFO', { stripeInvoices: {}, hasInvoices: false }, { root: true })
            this.invoiceKey = this.invoiceKey + 1;
        }
    }
}
</script>